import { useCallback } from 'react'
import { useMutation } from '@apollo/client/react'
import { AdminAPI, GraphQL } from '@guestgoodie/graphql'

export function useMarkAsRead(item: GraphQL.SimpleFeedbackFragmentFragment) {
  const [markRead, { loading }] = useMutation(
    AdminAPI.simpleFeedback.MARK_AS_READ
  )

  const markAsRead = useCallback(() => {
    markRead({
      variables: {
        id: item.id
      }
    })
  }, [item, markRead])

  return {
    markAsRead,
    loading
  }
}
